import React from 'react';
import DestinationTemplate from '../../components/DestinationTemplate';

const MaldivesPage = () => {
  return <DestinationTemplate destinationId="maldives" />;
};

export default MaldivesPage;
